// extracted by mini-css-extract-plugin
export default {"iconButton":"iconButton__rb5mF6","iconButtonDanger":"iconButtonDanger__dbtKDG"};